export default __webpack_public_path__ + "static/media/passLogo.1af6a1b2.svg";